import {
  before1,
  roofbefore,
  before3,
  after1,
  roofafter,
  after3,
  before5,
  after5,
  before6,
  after6,
  before7,
  after7,
  before8,
  after8,
  before4,
  after4,
  before9,
  after9,
  before10,
  after10,
  after11,
  before11,
  before12,
  after12,
  before13,
  after13,
  before14,
  after14,
  before15,
  after15,
  before16,
  after16,
  before17,
  after17,
  before18,
  after18,
  before19,
  after19,
  before20,
  after20,
  before21,
  after21,
  housebefore1,
  houseafter1,
} from "../assets/Gallery/Index";

const data = [
  {
    img1: housebefore1,
    img2: houseafter1,
  },
  {
    img1: before10,
    img2: after10,
  },
  {
    img1: before20,
    img2: after20,
  },
  {
    img1: before21,
    img2: after21,
  },

  {
    img1: before13,
    img2: after13,
  },

  {
    img1: roofbefore,
    img2: roofafter,
  },
];

export default data;
